var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdf = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 7C13 7 12 6 12 4V1H6C4 1 3 2 3 4V16C3 18 4 19 6 19H15C17 19 18 18 18 16V7H15Z",
    fill: "#4D6EF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H18L12 1V4C12 6 13 7 15 7Z",
    fill: "#4D6EF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24141 12.6202C8.24141 12.8236 8.19474 13.0102 8.10141 13.1802C8.00807 13.3469 7.86474 13.4819 7.67141 13.5852C7.47807 13.6886 7.23807 13.7402 6.95141 13.7402H6.42141V15.0002H5.56641V11.4902H6.95141C7.23141 11.4902 7.46807 11.5386 7.66141 11.6352C7.85474 11.7319 7.99974 11.8652 8.09641 12.0352C8.19307 12.2052 8.24141 12.4002 8.24141 12.6202ZM6.88641 13.0602C7.04974 13.0602 7.17141 13.0219 7.25141 12.9452C7.33141 12.8686 7.37141 12.7602 7.37141 12.6202C7.37141 12.4802 7.33141 12.3719 7.25141 12.2952C7.17141 12.2186 7.04974 12.1802 6.88641 12.1802H6.42141V13.0602H6.88641Z",
    fill: "#4D6EF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0015 11.4902C10.3715 11.4902 10.6949 11.5636 10.9715 11.7102C11.2482 11.8569 11.4615 12.0636 11.6115 12.3302C11.7649 12.5936 11.8415 12.8986 11.8415 13.2452C11.8415 13.5886 11.7649 13.8936 11.6115 14.1602C11.4615 14.4269 11.2465 14.6336 10.9665 14.7802C10.6899 14.9269 10.3682 15.0002 10.0015 15.0002H8.68652V11.4902H10.0015ZM9.94652 14.2602C10.2699 14.2602 10.5215 14.1719 10.7015 13.9952C10.8815 13.8186 10.9715 13.5686 10.9715 13.2452C10.9715 12.9219 10.8815 12.6702 10.7015 12.4902C10.5215 12.3102 10.2699 12.2202 9.94652 12.2202H9.54152V14.2602H9.94652Z",
    fill: "#4D6EF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6043 11.4902V12.1752H13.1743V12.9152H14.2443V13.5802H13.1743V15.0002H12.3193V11.4902H14.6043Z",
    fill: "#4D6EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdf);
export default ForwardRef;